import { createSlice } from "@reduxjs/toolkit";
import type { Family } from "../../../../shared/src/types/Family";
import type {  Task} from "../../../../shared/src/types/Task";
import type { Meeting } from "../../../../shared/src/types/Meeting";

export interface DashboardState {
  families: Family[];
  tasks: Task[];
  meetings: Meeting[];
  loading: boolean;
  error?: string;
}

const initialState: DashboardState = {
  families: [],
  tasks: [],
  meetings: [],
  loading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    
  },
});

export default dashboardSlice.reducer;